import { render, staticRenderFns } from "./batch_share_dwg.vue?vue&type=template&id=03354207&scoped=true&"
import script from "./batch_share_dwg.vue?vue&type=script&lang=js&"
export * from "./batch_share_dwg.vue?vue&type=script&lang=js&"
import style0 from "./batch_share_dwg.vue?vue&type=style&index=0&id=03354207&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03354207",
  null
  
)

export default component.exports